import React from "react";
import { HiOutlineLightBulb } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneThingsToDo } from "../../../lib/sysNavigation/SysNavigation";

type ThingsToDoRow = {
  things_to_do_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<ThingsToDoRow>
    type={_TYPES_.THINGSTODO}
    title="Things To Do"
    subtitle="Activity ideas promoted on the public site."
    icon={<HiOutlineLightBulb className="h-5 w-5" />}
    addRoute="/data/things/todo/add"
    editRoute="/data/things/todo/edit"
    pushOne={pushOneThingsToDo}
    dataKey="thingsToDos"
    countKey="thingsToDosCount"
    idField="things_to_do_id"
  />
);

export default Overview;
